export interface WorkerDetailLoadTicket {
    workerId: string;
    generation: number;
}

export class WorkerDetailRequestFence {
    private activeWorkerId: string | null;
    private loadedWorkerId: string | null = null;
    private generation = 0;

    constructor(workerId: string | null) {
        this.activeWorkerId = workerId;
    }

    activate(workerId: string | null): void {
        if (this.activeWorkerId === workerId) return;
        this.activeWorkerId = workerId;
        this.loadedWorkerId = null;
        this.generation += 1;
    }

    beginLoad(workerId: string): WorkerDetailLoadTicket {
        this.activate(workerId);
        this.loadedWorkerId = null;
        return { workerId, generation: ++this.generation };
    }

    isCurrent(ticket: WorkerDetailLoadTicket): boolean {
        return this.activeWorkerId === ticket.workerId && this.generation === ticket.generation;
    }

    accept(ticket: WorkerDetailLoadTicket): boolean {
        if (!this.isCurrent(ticket)) return false;
        this.loadedWorkerId = ticket.workerId;
        return true;
    }

    invalidate(): void {
        this.loadedWorkerId = null;
        this.generation += 1;
    }

    canSave(workerId: string): boolean {
        return this.activeWorkerId === workerId && this.loadedWorkerId === workerId;
    }

    beginOperation(workerId: string): WorkerDetailLoadTicket | null {
        if (this.activeWorkerId !== workerId) return null;
        return { workerId, generation: this.generation };
    }

    beginMutation(workerId: string): WorkerDetailLoadTicket | null {
        if (!this.canSave(workerId)) return null;
        return this.beginOperation(workerId);
    }
}
